import { Box, BoxProps } from '@mui/material';
import { forwardRef } from 'react';

type Edge = 'top' | 'right' | 'bottom' | 'left';

// See https://capacitorjs.com/docs/apis/system-bars#android-note
export const safeAreaInset = (edge: Edge): string => `var(--safe-area-inset-${edge}, env(safe-area-inset-${edge}, 0px))`;

interface Props extends BoxProps {
  edges?: Edge[];
  extra?: number;
}

const ALL: Edge[] = ['top', 'right', 'bottom', 'left'];

export const SafeArea = forwardRef<HTMLDivElement, Props>(({ edges = ALL, extra, sx, children, ...rest }, ref) => {
  const insetSx = edges.reduce<Record<string, string>>((acc, edge) => {
    const key = `padding${edge[0].toUpperCase()}${edge.slice(1)}`;
    const inset = safeAreaInset(edge);
    acc[key] = extra ? `calc(${extra}px + ${inset})` : inset;
    return acc;
  }, {});

  const callerSx = sx == null ? [] : Array.isArray(sx) ? sx : [sx];

  return (
    // insetSx comes last so a shorthand like `padding: 1`
    // cannot accidentally reset the safe-area inset on the chosen edges.
    <Box ref={ref} sx={[{ boxSizing: 'border-box' }, ...callerSx, insetSx]} {...rest}>
      {children}
    </Box>
  );
});
